import { useLocation } from "wouter";
import { Eye } from "lucide-react";
import { useDemoStore, roleLabels, roleHomes, type Role } from "@/store/useDemoStore";

const roles: Role[] = ["admin", "alumno", "evaluador", "dictaminador", "instructor", "auditor"];

export function RoleSwitcher() {
  const role = useDemoStore((s) => s.activeRole);
  const setRole = useDemoStore((s) => s.setRole);
  const [, setLocation] = useLocation();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "var(--cc-gray-100)",
        border: "1px solid var(--cc-gray-200)",
        borderRadius: 8,
        padding: "4px 8px 4px 10px",
      }}
      data-testid="role-switcher"
    >
      <Eye size={14} style={{ color: "var(--cc-gray-500)" }} />
      <span style={{ fontSize: 12, color: "var(--cc-gray-600)", fontWeight: 500 }}>Demo · ver como</span>
      <select
        value={role}
        onChange={(e) => {
          const r = e.target.value as Role;
          setRole(r);
          setLocation(roleHomes[r]);
        }}
        data-testid="select-role"
        style={{
          appearance: "none",
          background: "white",
          border: "1px solid var(--cc-gray-200)",
          borderRadius: 6,
          padding: "4px 26px 4px 10px",
          fontSize: 12,
          fontWeight: 600,
          color: "var(--cc-navy)",
          cursor: "pointer",
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 8px center",
          backgroundSize: "10px",
        }}
      >
        {roles.map((r) => (
          <option key={r} value={r}>
            {roleLabels[r]}
          </option>
        ))}
      </select>
    </div>
  );
}
